import type { RouteObject } from "react-router";
import { TaxList } from "./TaxList";

export const taxRoute: RouteObject = {
  path: "tax",
  element: <TaxList />,
};
